import {isNil} from 'ramda';

import type {useHttpCalls} from '../api/useHttpCalls';
import type {Preset} from '../types/Api';

type MigrationHttp = Pick<ReturnType<typeof useHttpCalls>, 'getPreset' | 'updateRenamePreset'>;

/** The rename API requires metadata, so read it fresh before migrating only the color. */
export async function migratePresetColor(preset: Preset, color: string, http: MigrationHttp) {
  if (!isNil(preset.color) || !/^#[0-9a-fA-F]{6}$/.test(color)) {
    return preset;
  }
  const current = (await http.getPreset(preset.id, {fresh: true, forCopy: true})) ?? null;
  if (isNil(current)) {
    return undefined;
  }
  if (!isNil(current.color)) {
    return {...preset, color: current.color};
  }
  await http.updateRenamePreset(preset.id, {
    title: current.title,
    description: current.description,
    color,
  });
  return {...preset, color};
}
